import { LoadingOverlay } from '@mantine/core';
import type { RefObject } from 'react';
import { ContentPlaceholder } from '../../../../components/content-placeholder/content-placeholder';
import { useSelectedInitiativeFocus } from '../../../../store/process-analysis-store/process-analysis-store.hooks';
import { useAutoSelectFilters } from '../../filters/initiative-focus/initiative-focus.hooks';
import { useInitiativeFocusData } from '../../hooks/initiative-data';
import { InitiativeFocusLineChart } from './line-chart/line-chart';

export const InitiativeFocus = ({ chartRef }: { chartRef: RefObject<HTMLDivElement | null> }) => {
  const selectedInitiativeFocus = useSelectedInitiativeFocus();
  const { data, isFetching, isLoading } = useInitiativeFocusData();

  useAutoSelectFilters();

  if (!isFetching && (!data || !data.initiatives || data.initiatives.length === 0)) {
    return <ContentPlaceholder />;
  }

  if (selectedInitiativeFocus.length === 0) {
    return <ContentPlaceholder noFiltersApplied />;
  }

  return (
    <div style={{ position: 'relative', height: '100%', width: '100%' }}>
      <LoadingOverlay visible={isLoading} overlayProps={{ blur: 2 }} style={{ zIndex: 200 }} />
      <InitiativeFocusLineChart ref={chartRef} />
    </div>
  );
};
